import { AxiosResponse } from 'axios'
import { IGenericEntityResponse } from 'services/core/entityResponseCore'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const EffectiveConsolidationServices = () => {
  const path = 'Consolidacao'

  const GetConsolidationByCompetence = async (
    flRecorrente: boolean
  ): Promise<
    AxiosResponse<IGenericEntityResponse<IGetAllEffectiveConsolidationDto>>
  > =>
    await RequestREAD.get(`${path}/GetAllPorCompetencia`, {
      headers: { flRecorrente: flRecorrente }
    })

  const UpdateConsolidacao = async (
    requestObj: IEffectiveConsolidation[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.put(`${path}/UpdateConsolidacaoRange`, {
      consolidacoes: requestObj
    })

  const ConsolidacaoCreteOrUpdate = async (
    requestObj: IEffectiveConsolidation[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/CreateOrUpdate`, {
      consolidacoes: requestObj
    })

  const ConsolidacaoVerificarContratosPendentesValidacao = async (): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/verificarContratosPendentesValidacao`);

  const PatchConfirmarConsolidacao = async (
    competencia: number,
    itensConsolidacao: IEffectiveConsolidation[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/ConsolidarCompetencia`, {
      competencia: competencia,
      itensConsolidacao: itensConsolidacao
    })

  const GetTurnOver = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<IGetTurnOverResponse>> =>
    RequestREAD.get(`${path}/GetAllConsolidacaoTurnOver`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetExcelTurnOver = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<any>> =>
    RequestREAD.get(`${path}/TurnOverExcel`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetAdesao = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<IGetAdesaoResponse>> => // TODO:
    RequestREAD.get(`${path}/GetAllConsolidacaoAdesao`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetExcelAdesao = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<any>> =>
    RequestREAD.get(`${path}/AdesaoExcel`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  return {
    ConsolidacaoCreteOrUpdate,
    ConsolidacaoVerificarContratosPendentesValidacao,
    GetAdesao,
    GetConsolidationByCompetence,
    GetExcelAdesao,
    GetExcelTurnOver,
    GetTurnOver,
    PatchConfirmarConsolidacao,
    UpdateConsolidacao
  }
}

export const ReportsConsolidationServices = () => {
  const path = 'ConsolidacaoRelatEfetivo'

  const GetHNomaisxHExtras = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<IGetHNomaisxHExtrasResponse>> =>
    await RequestREAD.get(`${path}/GetAllHorasNormaisTrabalhadaXHoraExtra`, {
      params: { idUsuario, isContraparte, FlReccorente: flRecorrente }
    })

  const GetExcelHNomaisxHExtras = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<any>> =>
    RequestREAD.get(`${path}/GetExcelHorasNormaisTrabalhadaXHoraExtra`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetPagamentoEfetivo = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<IGetPagamentoEfetivoResponse>> =>
    RequestREAD.get(`${path}/GetAllPagamentoEfetivo`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetExcelPagamentoEfetivo = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<any>> =>
    RequestREAD.get(`${path}/GetExcelPagamentoEfetivo`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetQuantidadeEfetivo = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<IGetQuantidadeDeEfetivoResponse>> =>
    RequestREAD.get(`${path}/GetAllQuantidadeEfetivo`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetExcelQuantidadeEfetivo = async (
    idUsuario: number,
    isContraparte: boolean,
    flRecorrente: boolean
  ): Promise<AxiosResponse<any>> =>
    RequestREAD.get(`${path}/GetExcelQuantidadeEfetivo`, {
      params: { idUsuario, isContraparte, flRecorrente }
    })

  const GetExcelBaseAnalise = async (params: {
    competenciaInicio: string
    competenciaFim: string,
    flRecorrente: boolean
  }): Promise<AxiosResponse> =>
    await RequestREAD.get(`${path}/GetBaseAnaliseExcel`, { params })

  return {
    GetExcelBaseAnalise,
    GetExcelHNomaisxHExtras,
    GetExcelPagamentoEfetivo,
    GetExcelQuantidadeEfetivo,
    GetHNomaisxHExtras,
    GetPagamentoEfetivo,
    GetQuantidadeEfetivo
  }
}

// Adesao
export interface IGetAdesaoResponse {
  entity: IGetAdesaoEntity
  sucesso: boolean
  mensagem: any
  detalhe: any
  tipo: any
}

export interface IGetAdesaoEntity {
  empresa: IGetAdesaoTable
  diretoriaExecutiva: IGetAdesaoTable
  area: IGetAdesaoTable
  unidadeNegocio: IGetAdesaoTable
}

export interface IGetAdesaoTable {
  itensConsolidacao: ItensConsolidacaoAdesao[]
  total: TotalAdesao
}

export interface ItensConsolidacaoAdesao {
  totalizadores: TotalizadoresAdesao
  itens: ItenAdesao[]
}

export interface TotalizadoresAdesao {
  idConsolidacao: number
  dsConsolidacao: string
  qtMobilizacaoMensal: number
  qtFornecedor: number
  nmUnidade: any
  idUnidadeGestora: number
  qtContratoPrincipal: number
  qtSubContrato: number
  qtTotalContratos: number
  qtTotalContrapartes: number
  qtContraparteNaoPreencheu: number
  peContrapartes: number
}

export interface ItenAdesao {
  idConsolidacao: number
  dsConsolidacao: string
  qtMobilizacaoMensal: number
  qtFornecedor: number
  nmUnidade: any
  idUnidadeGestora: number
  qtContratoPrincipal: number
  qtSubContrato: number
  qtTotalContratos: number
  qtTotalContrapartes: number
  qtContraparteNaoPreencheu: number
  peContrapartes: number
}

export interface TotalAdesao {
  idConsolidacao: number
  dsConsolidacao: string
  qtMobilizacaoMensal: number
  qtFornecedor: number
  nmUnidade: any
  idUnidadeGestora: number
  qtContratoPrincipal: number
  qtSubContrato: number
  qtTotalContratos: number
  qtTotalContrapartes: number
  qtContraparteNaoPreencheu: number
  peContrapartes: number
}
// ________

// TurnOver
export interface IGetTurnOverResponse {
  entity: IGetTurnOverEntity
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: any
}

export interface IGetTurnOverEntity {
  diretoriaExecutiva: ITurnOverTable
  empresa: ITurnOverTable
  area: ITurnOverTable
  unidadeNegocio: ITurnOverTable
}

export interface ITurnOverTable {
  itensConsolidacao: ItensConsolidacaoTurnOver[]
  total: TotalTurnOver
}

export interface ItensConsolidacaoTurnOver {
  totalizadores: TotalizadoresTurnOver
  itens: ItenTurnOver[]
}

export interface TotalizadoresTurnOver {
  idConsolidacao: number
  dsConsolidacao: string
  ativo: number
  idUnidadeGestora: number
  nmUnidade: any
  demitido: number
  acesso: number
  transferido: number
  afastado: number
  compartilhado: number
  totalEfetivo: number
  qtTotalSemDemitido: number
  turnOver: number
}

export interface ItenTurnOver {
  idConsolidacao: number
  dsConsolidacao: string
  ativo: number
  idUnidadeGestora: number
  nmUnidade: any
  demitido: number
  acesso: number
  transferido: number
  afastado: number
  compartilhado: number
  totalEfetivo: number
  qtTotalSemDemitido: number
  turnOver: number
}

export interface TotalTurnOver {
  idConsolidacao: number
  dsConsolidacao: string
  ativo: number
  idUnidadeGestora: number
  nmUnidade: any
  demitido: number
  acesso: number
  transferido: number
  afastado: number
  compartilhado: number
  totalEfetivo: number
  qtTotalSemDemitido: number
  turnOver: number
}
// _______

export interface Info {
  qtdTotalEfetivo?: number;
  horaExtra?: number;
  horaNormal?: number;
  vlPagamento?: number
}

export interface Total {
  ano: number;
  mes: number;
  info: Info;
}

export interface UnidadeGestoraInfo {
  variacao: number;
  idUnidadeGestora: number;
  nmUnidadeGestora: string;
  informaoAnoMeses: InformaoAnoMes[];
}

export interface InformaoAnoMes {
  ano: number;
  mes: number;
  info: Info;
}

export interface Item {
  variacao: number;
  unidadeGestoraInfo: UnidadeGestoraInfo[];
  idGrupoConsolidacao: number;
  nmGrupoConsolidacao: string;
  informaoAnoMeses: InformaoAnoMes[];
}

export interface IItensConsolidacao {
  idConsolidacao: number;
  dsConsolidacao: string;
  ativo: number;
  idUnidadeGestora: number;
  nmUnidade?: any;
  demitido: number;
  acesso: number;
  transferido: number;
  afastado: number;
  compartilhado: number;
  totalEfetivo: number;
  qtTotalSemDemitido: number;
  turnOver: number;
}

export interface ITotalizadoresConsolidacao {
  idConsolidacao: number;
  dsConsolidacao: string;
  ativo: number;
  idUnidadeGestora: number;
  nmUnidade?: any;
  demitido: number;
  acesso: number;
  transferido: number;
  afastado: number;
  compartilhado: number;
  totalEfetivo: number;
  qtTotalSemDemitido: number;
  turnOver: number;
}

export interface ItemConsolidacao {
  idConsolidacao: number;
  dsConsolidacao: string;
  ativo: number;
  idUnidadeGestora: number;
  nmUnidade?: any;
  demitido: number;
  acesso: number;
  transferido: number;
  afastado: number;
  compartilhado: number;
  totalEfetivo: number;
  qtTotalSemDemitido: number;
  turnOver: number;
}

export interface IItensConsolidacao {
  itens: ItemConsolidacao[]
  totalizadores: ItemConsolidacao[]
}

export interface IConsolidacaoTableEntity {
  items: Item[]
  total: Total[]
}

export interface IGetPagamentoEfetivoResponse {
  entity: Entity;
  sucesso: boolean;
  mensagem?: any;
  detalhe?: any;
  tipo?: any;
}

export interface Entity {
  area: IConsolidacaoTableEntity;
  empresa: IConsolidacaoTableEntity;
  unidadeNegocio: IConsolidacaoTableEntity;
  diretoria: IConsolidacaoTableEntity;
}

export interface IGetQuantidadeDeEfetivoResponse {
  entity: Entity;
  sucesso: boolean;
  mensagem?: any;
  detalhe?: any;
  tipo?: any;
}

export interface IGetHNomaisxHExtrasResponse {
  entity: Entity;
  sucesso: boolean;
  mensagem?: any;
  detalhe?: any;
  tipo?: any;
}

export interface IResponseGetConsolidation {
  entity: IEffectiveConsolidation[]
  sucesso: boolean
  mensagem: string
  detalhe: string
  tipo: string
}

export interface IGetAllEffectiveConsolidationDto {
  flDiaFechamentoAnalista: boolean
  itensConsolidacao: IEffectiveConsolidation[]
}

export interface IEffectiveConsolidation {
  idConsolidacao: number
  nuAnoMesCompetencia: number
  unidadeGestoraId: number
  diretoriaExecutivaId: number
  empresaId: number
  areaId: number
  unidadeNegocioId: number
  flConsolidado: boolean
  nmUnidadeGestora?: string
}

export interface IInfosMeses {
  qtdTotalEfetivo: number
  horaNormal: number
  horaExtra: number
  vlPagamento: number
}

export interface IInformacaoMeses {
  info: IInfosMeses
}

export interface IUnidadeGestoraInfo {
  info: IInfosMeses
  nmUnidadeGestora: string
  variacao: number
  informaoAnoMeses: IInformacaoMeses[]
}

export interface IAuxReportConsolidation {
  variacao: number
  unidadeGestoraInfo: IUnidadeGestoraInfo[]
  idGrupoConsolidacao: number
  nmGrupoConsolidacao: string
  informaoAnoMeses: IInformacaoMeses[]
}

export interface ITotalizadoresAndItensTurnOverContent {
  idConsolidacao: number
  dsConsolidacao: string
  ativo: number
  demitido: number
  afastado: number
  acesso: number
  transferido: number
  compartilhado: number
  totalEfetivo: number
  qtTotalSemDemitido: number
  turnOver: number
}

export interface ITurnOver {
  totalizadores: ITotalizadoresAndItensTurnOverContent
  itens: ITotalizadoresAndItensTurnOverContent[]
}

export interface ITotalizadoresAndItensAdhesionContent {
  idConsolidacao: number
  dsConsolidacao: string
  qtMobilizacaoMensal: number
  qtFornecedor: number
  qtContratoPrincipal: number
  qtSubContrato: number
  qtTotalContratos: number
  qtTotalContrapartes: number
  qtContraparteNaoPreencheu: number
  peContrapartes: number
}

export interface IAdhesion {
  totalizadores: ITotalizadoresAndItensAdhesionContent
  itens: ITotalizadoresAndItensAdhesionContent[]
}
